import { render } from "./GalleImages.vue?vue&type=template&id=624680b6&scoped=true"
import script from "./GalleImages.vue?vue&type=script&lang=js"
export * from "./GalleImages.vue?vue&type=script&lang=js"

import "./GalleImages.vue?vue&type=style&index=0&id=624680b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624680b6"]])

export default __exports__